import gql from "graphql-tag";

export default gql`
  fragment AnswerablePostFields on AnswerablePost {
    answeredAt
    answeredBy {
      _id
      fullName
    }
  }
`;
